import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import _intersection from 'underscore/modules/intersection';
import * as Yup from 'yup';
import RolesForm from './RolesForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import schema from 'react/shared/utils/schemas';
import trackUserData from 'react/signups/card/common/MarketoTracker';
import WizardCard from 'react/signups/card/common/WizardCard';
import cardForDataShape from 'react/signups/card/shapes/CardForData';

export default function Roles({ cardForData, moduleComplete, setCardForData }) {
  const paidCaregiverQuestionIsRequired = (values) =>
    _intersection(values, ['disability', 'elder', 'mental-health-challenges', 'other']).length > 0;

  const validationSchema = Yup.object().shape({
    firstName: schema.firstName.required(),
    lastName: schema.lastName.required(),
    cardFor: Yup.array().min(1, 'Please select at least one option'),
    cardForOther: Yup.string().when('cardFor', (values) =>
      values.includes('other')
        ? Yup.string().required('This field is required')
        : Yup.string().nullable(),
    ),
    cardForPaidCaregiver: Yup.string().when('cardFor', (values) =>
      paidCaregiverQuestionIsRequired(values)
        ? Yup.string().nullable().required('The paid caregiver question is required')
        : Yup.string().nullable(),
    ),
  });

  const handleContinue = (values) => {
    const cardForPaidCaregiver = paidCaregiverQuestionIsRequired(values.cardFor)
      ? values.cardForPaidCaregiver
      : null;
    const marketoFieldForPaidCaregiverAnswer = 'Card_for_caregiver__c';

    trackUserData({
      Company: `${values.firstName} ${values.lastName}`,
      [marketoFieldForPaidCaregiverAnswer]: cardForPaidCaregiver,
    });
    setCardForData({
      firstName: values.firstName,
      lastName: values.lastName,
      cardFor: values.cardFor,
      cardForOther: values.cardForOther,
      cardForPaidCaregiver,
    });
  };

  return (
    <>
      <WizardCard>
        <CardHeader>Tell us a little more about them</CardHeader>
        <Formik
          initialValues={cardForData}
          onSubmit={handleContinue}
          validationSchema={validationSchema}
        >
          {({ handleChange, handleSubmit, setFieldTouched, setFieldValue, values }) => (
            <>
              <RolesForm
                onChange={handleChange}
                paidCaregiverQuestionIsRequired={paidCaregiverQuestionIsRequired}
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}
                values={values}
              />
              <NextPageButton disabled={moduleComplete} onClick={handleSubmit} />
            </>
          )}
        </Formik>
      </WizardCard>
    </>
  );
}

Roles.propTypes = {
  cardForData: cardForDataShape.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  setCardForData: PropTypes.func.isRequired,
};
